import isEmpty from 'lodash/isEmpty'
import axios from 'axios'
import makeDebug from 'debug'
import qs from 'qs'
import wcs from '@/scripts/libs/wcs'
import { WcsFrameAdvisorResponse } from '@/types/frame-genius'
import { normalizeFrameAdvisorKeysProduct } from '@/scripts/libs/frame-genius'

const debug = makeDebug('wcs:frame-advisor')
export const loadProductsByPartNumber = async (partNumber: string[]) => {
  const endpoint = wcs.getEndPoint('frameAdvisorProducts')
  const { storeId, catalogId, langId } = wcs.getStoreConfig()
  const params = {
    catalogId,
    langId,
    storeId,
    partNumber,
  }
  const stringifiedParams = qs.stringify(params, { indices: false })
  const url = `${endpoint}?${stringifiedParams}`
  const response = await axios.get<WcsFrameAdvisorResponse>(url)
  debug(response.data)
  return response.data.frameAdvisorProducts.map(normalizeFrameAdvisorKeysProduct)
}

export const saveProfileData = async (profileData: any) => {
  const endpoint = wcs.getEndPoint('frameAdvisorProfileData')
  await axios.post(endpoint, profileData)

  return {
    success: true,
  }
}

export const getProfileData = async () => {
  const endpoint = wcs.getEndPoint('frameAdvisorProfileData')
  const response = await axios.get(endpoint)

  const profileData = response.data

  if (!isEmpty(profileData)) {
    if (typeof profileData === 'string') {
      return JSON.parse(profileData)
    } else {
      return profileData
    }
  } else {
    return {}
  }
}
